export enum StatusClass {
  INFORMATIONAL = '1XX',
  SUCCESS = '2XX',
  REDIRECTION = '3XX',
  CLIENT_ERROR = '4XX',
  SERVER_ERROR = '5XX',
}

export interface HttpStatus {
  status: number;
}

export class HttpError {
  private _status: number;

  constructor(status: number) {
    this._status = status;
  }

  get status(): number {
    return this._status;
  }

  get statusClass(): StatusClass {
    if (Math.round(this._status / 100) === 4) {
      return StatusClass.CLIENT_ERROR;
    } else {
      return StatusClass.SERVER_ERROR;
    }
  }
}
